import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ComanServices from '../../../services/ComanServices';

function BlogUpdate({ notification, closeModal }) {
  // console.log(notification)
  const [formValues, setFormValues] = useState({
    title: '',
    author: '',
    startDate: '',
    endDate: '',
    description: '',
    file: null,
  });

  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); 

  useEffect(() => {
    if (notification) {
      console.log(notification)
      setFormValues({
        title: notification?.title || '',
        author: notification?.author || '',
        startDate: notification?.startDate || '',
        endDate: notification?.endDate || '',
        description: notification?.description || '',
        file: notification?.image || '',
      });
      if (notification.image) {
        setPreviewImage(process.env.REACT_APP_URL + notification.image);
      }
    }
  }, [notification]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleDescriptionChange = (value) => {
    setFormValues({
      ...formValues,
      description: value,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        file: file,
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append('title', formValues.title);
    formData.append('author', formValues.author);
    formData.append('startDate', formValues.startDate);
    formData.append('endDate', formValues.endDate);
    formData.append('description', formValues.description);
    if (formValues.file instanceof File) {
      formData.append('image', formValues.file);
    }

    try {
      await ComanServices.updateBlog(notification._id, formData);
      alert('Blog updated successfully');
      closeModal();
    } catch (error) {
      console.error('Failed to update blog', error);
      alert('Failed to update blog');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Blog Update</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="input-field">
                          <label>Title</label>
                          <input
                            type="text"
                            name="title"
                            value={formValues.title}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="input-field">
                          <label>Author</label>
                          <input
                            type="text"
                            name="author"
                            value={formValues.author}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-3 col-sm-6">
                        <div className="input-field">
                          <label>Start Date</label>
                          <input
                            type="date"
                            name="startDate"
                            value={formValues.startDate}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-3 col-sm-6">
                        <div className="input-field">
                          <label>End Date</label>
                          <input
                            type="date"
                            name="endDate"
                            value={formValues.endDate}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="input-field">
                          <label>Upload Image</label>
                          <input
                            type="file"
                            name="file"
                            onChange={handleFileChange}
                            className="form-control"
                          />
                          <p>
                            Supported formats: png, jpeg, jpg, webp
                          </p>
                          <div className="file-preview text-center">
                            <img
                              src={previewImage}
                              alt="your image"
                              style={{ maxWidth: '150px', maxHeight: '150px' }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="input-field">
                          <label>Description</label>
                          <ReactQuill
                            value={formValues.description}
                            onChange={handleDescriptionChange}
                            theme="snow"
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <button type="submit" className="submit-green-btn">
                      SUBMIT
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogUpdate;
